const FiscalCategory = Object.freeze({
  TAXABLE : 'taxable',
  NON_TAXABLE : 'non_taxable',
  EXEMPT : 'exempt',
  CO_CONTRACTOR : 'co_contractor',
  INTRA_EU : 'intra_eu',
})

export default FiscalCategory
